<div class="card" *ngIf="CONTENT_BOUNDS?.sections?.verify_client; let section">
    <div class="card-content">
        <div class="voxel-col-12" *ngIf="customerError?.value">
            <voxel-alert [type]="CONTENT_BOUNDS?.error_notification?.type" light class="voxel-mb-2"
                [icon]="CONTENT_BOUNDS?.error_notification?.icon">
                {{this.CONTENT_BOUNDS?.error_notification?.text}}
            </voxel-alert>
        </div>

        <p>{{section?.title}}</p>        

        <form [formGroup]="form" autocomplete="off">

            <div class="voxel-row" *ngIf="this.documentTypeList.length>0">
                <voxel-form-field *ngIf="CONTENT_BOUNDS?.sections?.verify_client?.controls?.document_type; let control;"
                    class="voxel-col-4 voxel-col-xs-4 voxel-col-sm-4 voxel-col-md-6 " [label]="control?.label"
                    [msgErr]="(getMessageError({label: control?.label, formControlName: (control?.formControlName + '_temp')}, form.get((control?.formControlName + '_temp'))?.errors) | async) || control?.msgErr">
                    <input type="text" voxelInput voxelAutocomplete #includesFilterInputDocument="voxelAutocomplete"
                        [placeholder]="control?.description" [formControlName]="(control?.formControlName + '_temp')" />
                    <app-clean-autocomplete [autocomplete]="documentTypesAutocomplete"></app-clean-autocomplete>
                    <voxel-autocomplete #documentTypesAutocomplete [input]="includesFilterInputDocument"
                        filterMode="includes" (optionSelected)="onChangeEvent()">
                        <voxel-option *ngFor="let option of documentTypeList" [value]="option.id" [disabled]="false">
                            {{ option?.name | unicode}}
                        </voxel-option>
                    </voxel-autocomplete>
                </voxel-form-field>
                <voxel-form-field
                    *ngIf="CONTENT_BOUNDS?.sections?.verify_client?.controls?.document_number; let control;"
                    class="voxel-col-4 voxel-col-xs-4 voxel-col-sm-4 voxel-col-md-6" [label]="control?.label"
                    [msgErr]="(getMessageError({label: control?.label, formControlName:(control?.formControlName + '_temp')}, form.get((control?.formControlName + '_temp'))?.errors) | async) || control?.msgErr">
                    <input voxelInput [placeholder]="control?.description"
                        [formControlName]="(control?.formControlName + '_temp')" (change)="onChangeEvent()" />
                </voxel-form-field>
            </div>
        </form>

        <div class="actions">
            <div class="voxel-row" *ngIf="CONTENT_BOUNDS?.sections?.verify_client?.controls; let controls">
                <button *ngIf="!isLoading && !CONTENT_BOUNDS?.buttons?.verify_client?.hidden"
                    [disabled]="!form.get(controls?.document_type?.formControlName + '_temp')?.valid || !form.get(controls?.document_number?.formControlName + '_temp')?.valid"
                    (click)="findClientEvent()" voxelButtonContextual
                    class="voxel-col-12 voxel-col-sm-3 voxel-col-md-3">
                    {{this.CONTENT_BOUNDS?.buttons?.verify_client?.caption}}
                </button>

                <voxel-loading-circle *ngIf="isLoading" class="loading voxel-col-12"
                    [loadingTitle]="CONTENT_BOUNDS?.load_text"></voxel-loading-circle>

                <button #defaultOriginDialogButtons="voxelOverlayOrigin" voxelOverlayOrigin class="no-visible"></button>

                <voxel-dialog [dialogOrigin]="defaultOriginDialogButtons" [id]="'dialog-b'"
                    [buttonAlignment]="'horizontal'" [dialogIsOpen]="showDialogConfirm">
                    <p>Si desea consultar un nuevo cliente perderá la información ingresada previamente,</p>
                    <p>¿Deseas continuar?</p>
                    <div voxelDialogFooter>
                        <button voxelButtonContextual (click)="dialogButtonClicked({type:'action1'})">
                            Cancelar
                        </button>
                        <button voxelButtonContextual (click)="dialogButtonClicked({type:'action2'})">
                            Aceptar
                        </button>
                    </div>
                </voxel-dialog>
                <voxel-dialog [dialogOrigin]="defaultOriginDialogButtons" [id]="'dialog-c'"
                    [buttonAlignment]="'horizontal'" [dialogIsOpen]="showDialogRiskNvl">
                    <p>{{textDialogRiskNvl}}</p>
                    <p>¿Deseas continuar?</p>
                    <div voxelDialogFooter>
                        <button voxelButtonContextual (click)="dialogRiskButtonClicked({type:'action1'})">
                            Cancelar
                        </button>
                        <button voxelButtonContextual (click)="dialogRiskButtonClicked({type:'action2'})">
                            Aceptar
                        </button>
                    </div>
                </voxel-dialog>
            </div>
        </div>

    </div>
</div>

<ng-container *ngIf="customerLoaded?.value">
    <ng-container *ngIf="isVisible('message_not_found')">
        <div class="voxel-col-12" *ngIf="!customerExists?.value&&!customerError?.value">
            <voxel-alert [type]="CONTENT_BOUNDS?.not_found_notification?.type" light class="voxel-mb-2"
                [icon]="CONTENT_BOUNDS?.not_found_notification?.icon">
                {{this.CONTENT_BOUNDS?.not_found_notification?.text}}
            </voxel-alert>
        </div>
    </ng-container>
    <ng-container *ngIf="isVisible('message_terms')">
        <div class="voxel-col-12">
            <voxel-alert [type]="CONTENT_BOUNDS?.terms_notification?.type" light class="voxel-mb-2"
                [icon]="CONTENT_BOUNDS?.terms_notification?.icon">
                {{this.CONTENT_BOUNDS?.terms_notification?.text}}
            </voxel-alert>
        </div>
    </ng-container>


    <voxel-accordion-group>
        <voxel-accordion 
            [isOpened]="true"
            *ngIf="(customerExists?.value && showLabelsClientData) || !customerExists?.value && isVisible('section_data')"
            [accordionTitle]="CONTENT_BOUNDS?.sections?.basic_data?.title"
            [description]="customerExists?.value ? CONTENT_BOUNDS?.sections?.basic_data?.caption_exists : CONTENT_BOUNDS?.sections?.basic_data?.caption_main">

            <ng-container *ngIf="customerExists?.value && showLabelsClientData">
                <div [ngClass]="{validation: customerValidation?.value}"
                    *ngIf="CONTENT_BOUNDS?.sections?.basic_data; let section">
                    <form class="form-opcional-data" [formGroup]="form" autocomplete="off">
                        <div class="voxel-row readonly-items">
                            <ng-container
                                *ngIf="customerValidation?.value && !isNaturalPerson && _nameLength ? CONTENT_BOUNDS?.sections?.basic_data?.controls?.company_name : CONTENT_BOUNDS?.sections?.basic_data?.controls?.client_names; let control">
                                <voxel-form-field *ngIf="showInputData(control?.formControlName)"
                                    class="voxel-col-4 voxel-col-xs-4 voxel-col-sm-4 voxel-col-md-6"
                                    [label]="control?.label"
                                    [msgErr]="(getMessageError(control, form.get(control?.formControlName)?.errors) | async) || control?.msgErr">
                                    <input voxelInput [placeholder]="control?.description"
                                        [formControlName]="control?.formControlName" minlength="2"
                                        [maxlength]="_nameLength" />
                                </voxel-form-field>
                            </ng-container>
                            <div class="voxel-col-12 voxel-col-sm-12 voxel-col-md-12 readonly-item"
                                *ngIf="!customerValidation?.value && CONTENT_BOUNDS?.sections?.basic_data?.controls?.client_names; let control">
                                <p class="readonly-item-title">{{control?.label}}</p>
                                <span
                                    class="readonly-item-value">{{form.get(section?.controls?.client_names?.formControlName)?.value}}
                                    {{form.get(section?.controls?.client_surnames?.formControlName)?.value}}</span>
                            </div>

                            <ng-container
                                *ngIf="customerValidation?.value && isNaturalPerson && CONTENT_BOUNDS?.sections?.basic_data?.controls?.client_surnames; let control">
                                <voxel-form-field *ngIf="showInputData(control?.formControlName)"
                                    class="voxel-col-4 voxel-col-xs-4 voxel-col-sm-4 voxel-col-md-6"
                                    [label]="control?.label"
                                    [msgErr]="(getMessageError(control, form.get(control?.formControlName)?.errors) | async) || control?.msgErr">
                                    <input voxelInput [placeholder]="control?.description"
                                        [formControlName]="control?.formControlName" minlength="2"
                                        [maxlength]="_nameLength" />
                                </voxel-form-field>
                            </ng-container>

                            <ng-container *ngIf="CONTENT_BOUNDS?.sections?.basic_data?.controls?.state; let control">
                                <voxel-form-field
                                    *ngIf="showInputData(control?.formControlName) || showInputData(CONTENT_BOUNDS?.sections?.basic_data?.controls?.city?.formControlName)"
                                    class="voxel-col-4 voxel-col-xs-4 voxel-col-sm-4 voxel-col-md-6 "
                                    [label]="control?.label"
                                    [msgErr]="(getMessageError(control, form.get(control?.formControlName)?.errors) | async) || control?.msgErr">
                                    <input type="text" voxelInput voxelAutocomplete
                                        #includesFilterInputState="voxelAutocomplete"
                                        [formControlName]="(control?.formControlName)" />
                                    <app-clean-autocomplete
                                        [autocomplete]="statesAutocomplete"></app-clean-autocomplete>
                                    <voxel-autocomplete #statesAutocomplete [input]="includesFilterInputState"
                                        filterMode="includes">
                                        <voxel-option value="">{{control?.description}}</voxel-option>
                                        <voxel-option *ngFor="let option of statesList" [value]="option?.id">
                                            {{ option?.name }}
                                        </voxel-option>
                                    </voxel-autocomplete>
                                </voxel-form-field>
                            </ng-container>
                            <ng-container *ngIf="CONTENT_BOUNDS?.sections?.basic_data?.controls?.city; let control">
                                <voxel-form-field
                                    *ngIf="showInputData(control?.formControlName) || showInputData(CONTENT_BOUNDS?.sections?.basic_data?.controls?.state?.formControlName)"
                                    class="voxel-col-4 voxel-col-xs-4 voxel-col-sm-4 voxel-col-md-6 "
                                    [label]="control?.label"
                                    [msgErr]="(getMessageError(control, form.get(control?.formControlName)?.errors) | async) || control?.msgErr">
                                    <input type="text" voxelInput voxelAutocomplete
                                        #includesFilterInputCities="voxelAutocomplete"
                                        [formControlName]="(control?.formControlName)" />
                                    <app-clean-autocomplete
                                        [autocomplete]="citiesAutocomplete"></app-clean-autocomplete>
                                    <voxel-autocomplete #citiesAutocomplete [input]="includesFilterInputCities"
                                        filterMode="includes">
                                        <voxel-option value="">{{control?.description}}</voxel-option>
                                        <voxel-option *ngFor="let option of citiesList" [value]="option?.id">
                                            {{ option?.name }}
                                        </voxel-option>
                                    </voxel-autocomplete>
                                </voxel-form-field>
                            </ng-container>
                            <div class="voxel-col-6 voxel-col-sm-4 voxel-col-md-6 readonly-item"
                                *ngIf="!customerValidation?.value && !(showInputData(CONTENT_BOUNDS?.sections?.basic_data?.controls?.city?.formControlName) || showInputData(CONTENT_BOUNDS?.sections?.basic_data?.controls?.state?.formControlName)) && section?.controls?.state; let control">
                                <p class="readonly-item-title">{{control?.label}}</p>
                                <span class="readonly-item-value">{{form.get(control?.formControlName)?.value |
                                    itemName:"id":"name":statesList }}</span>
                            </div>
                            <div class="voxel-col-6 voxel-col-sm-4 voxel-col-md-6 readonly-item"
                                *ngIf="!customerValidation?.value && !(showInputData(CONTENT_BOUNDS?.sections?.basic_data?.controls?.city?.formControlName) || showInputData(CONTENT_BOUNDS?.sections?.basic_data?.controls?.state?.formControlName)) && section?.controls?.city; let control">
                                <p class="readonly-item-title">{{control?.label}}</p>
                                <span class="readonly-item-value">{{form.get(control?.formControlName)?.value |
                                    itemName:"id":"name":citiesList }}</span>
                            </div>
                            <ng-container *ngIf="CONTENT_BOUNDS?.sections?.basic_data?.controls?.address; let control">
                                <voxel-form-field *ngIf="showInputData(control?.formControlName)"
                                    class="voxel-col-xs-4 voxel-col-sm-4 voxel-col-md-6" [label]="control?.label"
                                    [msgErr]="(getMessageError(control, form.get(control?.formControlName)?.errors) | async) || control?.msgErr">
                                    <input voxelInput [placeholder]="control?.description"
                                        [formControlName]="control?.formControlName" />
                                </voxel-form-field>
                            </ng-container>
                            <div class="voxel-col-6 voxel-col-sm-4 voxel-col-md-6 readonly-item"
                                *ngIf="!customerValidation?.value && !showInputData(CONTENT_BOUNDS?.sections?.basic_data?.controls?.address?.formControlName) && section?.controls?.address; let control">
                                <p class="readonly-item-title">{{control?.label}}</p>
                                <span class="readonly-item-value">{{form.get(control?.formControlName)?.value}}</span>
                            </div>
                            <ng-container *ngIf="CONTENT_BOUNDS?.sections?.basic_data?.controls?.segment; let control">
                                <voxel-form-field
                                    *ngIf="showInputData(control?.formControlName) || showInputData(CONTENT_BOUNDS?.sections?.basic_data?.controls?.subsegment?.formControlName)"
                                    class="voxel-col-xs-4 voxel-col-sm-4 voxel-col-md-6 voxel-col-6"
                                    [label]="control?.label"
                                    [msgErr]="(getMessageError(control, form.get(control?.formControlName)?.errors) | async) || control?.msgErr">
                                    <voxel-select [formControlName]="control?.formControlName"
                                        [placeholder]="control?.description">
                                        <voxel-option *ngFor="let option of segmentList" [value]="option?.id"
                                            [disabled]="false">
                                            {{ option.name }}
                                        </voxel-option>
                                    </voxel-select>
                                </voxel-form-field>
                            </ng-container>
                            <ng-container
                                *ngIf="CONTENT_BOUNDS?.sections?.basic_data?.controls?.subsegment; let control">
                                <voxel-form-field
                                    *ngIf="showInputData(control?.formControlName) || showInputData(CONTENT_BOUNDS?.sections?.basic_data?.controls?.segment?.formControlName)"
                                    class="voxel-col-xs-4 voxel-col-sm-4 voxel-col-md-6 voxel-col-6"
                                    [label]="control?.label"
                                    [msgErr]="(getMessageError(control, form.get(control?.formControlName)?.errors) | async) || control?.msgErr">
                                    <voxel-select [formControlName]="control?.formControlName"
                                        [placeholder]="control?.description">
                                        <voxel-option *ngFor="let option of subsegmentList" [value]="option?.id"
                                            [disabled]="false">
                                            {{ option.name }}
                                        </voxel-option>
                                    </voxel-select>
                                </voxel-form-field>
                            </ng-container>
                            <div class="voxel-col-6 voxel-col-sm-4 voxel-col-md-6 readonly-item"
                                *ngIf="!customerValidation?.value && !(showInputData(CONTENT_BOUNDS?.sections?.basic_data?.controls?.segment?.formControlName) || showInputData(CONTENT_BOUNDS?.sections?.basic_data?.controls?.subsegment?.formControlName)) && section?.controls?.segment; let control">
                                <p class="readonly-item-title">{{control?.label}}</p>
                                <span class="readonly-item-value">{{form.get(control?.formControlName)?.value |
                                    itemName:"id":"name":segmentList }}</span>
                            </div>
                            <div class="voxel-col-6 voxel-col-sm-4 voxel-col-md-6 readonly-item"
                                *ngIf="!customerValidation?.value && !(showInputData(CONTENT_BOUNDS?.sections?.basic_data?.controls?.segment?.formControlName) || showInputData(CONTENT_BOUNDS?.sections?.basic_data?.controls?.subsegment?.formControlName)) && section?.controls?.subsegment; let control">
                                <p class="readonly-item-title">{{control?.label}}</p>
                                <span class="readonly-item-value">{{form.get(control?.formControlName)?.value |
                                    itemName:"id":"name":subsegmentList }}</span>
                            </div>
                            <ng-container *ngIf="CONTENT_BOUNDS?.sections?.basic_data?.controls?.gender; let control">
                                <voxel-form-field *ngIf="showInputData(control?.formControlName) && isNaturalPerson"
                                    class="voxel-col-xs-4 voxel-col-sm-4 voxel-col-md-6" [label]="control?.label"
                                    [msgErr]="(getMessageError(control, form.get(control?.formControlName)?.errors) | async) || control?.msgErr">
                                    <voxel-select [formControlName]="control?.formControlName"
                                        [placeholder]="control?.description">
                                        <voxel-option *ngFor="let option of genderList" [value]="option?.id"
                                            [disabled]="false">
                                            {{ option.name }}
                                        </voxel-option>
                                    </voxel-select>
                                </voxel-form-field>
                            </ng-container>
                            <div class="voxel-col-6 voxel-col-sm-4 voxel-col-md-6 readonly-item"
                                *ngIf="!customerValidation?.value && !showInputData(control?.formControlName) && section?.controls?.gender; let control">
                                <div *ngIf="isNaturalPerson">
                                    <p class="readonly-item-title">{{control?.label}}</p>
                                    <span class="readonly-item-value">{{form.get(control?.formControlName)?.value |
                                        itemName:"id":"name":genderList }}</span>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </ng-container>
            <ng-container *ngIf="!customerExists?.value">
                <div *ngIf="(isVisible('section_data'))">
                    <form class="form-basic-data" [formGroup]="form" autocomplete="off">
                        <div class="voxel-row">

                            <voxel-form-field
                                *ngIf="!isNaturalPerson && _nameLength ? CONTENT_BOUNDS?.sections?.basic_data?.controls?.company_name : CONTENT_BOUNDS?.sections?.basic_data?.controls?.client_names; let control"
                                class="voxel-col-xs-4 voxel-col-sm-4 voxel-col-md-6" [label]="control?.label"
                                [msgErr]="(getMessageError(control, form.get(control?.formControlName)?.errors) | async) || control?.msgErr">
                                <input voxelInput [placeholder]="control?.description"
                                    [formControlName]="control?.formControlName" minlength="2"
                                    [maxlength]="_nameLength" />
                            </voxel-form-field>

                            <ng-container *ngIf="isNaturalPerson">
                                <voxel-form-field
                                    *ngIf="CONTENT_BOUNDS?.sections?.basic_data?.controls?.client_surnames; let control"
                                    class="voxel-col-xs-4 voxel-col-sm-4 voxel-col-md-6" [label]="control?.label"
                                    [msgErr]="(getMessageError(control, form.get(control?.formControlName)?.errors) | async) || control?.msgErr">
                                    <input voxelInput [placeholder]="control?.description"
                                        [formControlName]="control?.formControlName" minlength="2"
                                        [maxlength]="_nameLength" />
                                </voxel-form-field>
                            </ng-container>



                            <voxel-form-field *ngIf="CONTENT_BOUNDS?.sections?.basic_data?.controls?.state; let control"
                                class="voxel-col-xs-4 voxel-col-sm-4 voxel-col-md-6 " [label]="control?.label"
                                [msgErr]="(getMessageError(control, form.get(control?.formControlName)?.errors) | async) || control?.msgErr">
                                <input type="text" voxelInput voxelAutocomplete
                                    #includesFilterInputState="voxelAutocomplete"
                                    [formControlName]="(control?.formControlName)" />
                                <app-clean-autocomplete [autocomplete]="statesAutocomplete"></app-clean-autocomplete>
                                <voxel-autocomplete #statesAutocomplete [input]="includesFilterInputState"
                                    filterMode="includes">
                                    <voxel-option value="">{{control?.description}}</voxel-option>
                                    <voxel-option *ngFor="let option of statesList" [value]="option?.id">
                                        {{ option?.name }}
                                    </voxel-option>
                                </voxel-autocomplete>
                            </voxel-form-field>

                            <ng-container
                                *ngIf="citiesList && form.get(CONTENT_BOUNDS?.sections?.basic_data?.controls?.state?.formControlName)?.value">
                                <voxel-form-field
                                    *ngIf="CONTENT_BOUNDS?.sections?.basic_data?.controls?.city; let control"
                                    class="voxel-col-xs-4 voxel-col-sm-4 voxel-col-md-6 " [label]="control?.label"
                                    [msgErr]="(getMessageError(control, form.get(control?.formControlName)?.errors) | async) || control?.msgErr">
                                    <input type="text" voxelInput voxelAutocomplete
                                        #includesFilterInputCities="voxelAutocomplete"
                                        [formControlName]="(control?.formControlName)" />
                                    <app-clean-autocomplete
                                        [autocomplete]="citiesAutocomplete"></app-clean-autocomplete>
                                    <voxel-autocomplete #citiesAutocomplete [input]="includesFilterInputCities"
                                        filterMode="includes">
                                        <voxel-option value="">{{control?.description}}</voxel-option>
                                        <voxel-option *ngFor="let option of citiesList" [value]="option?.id">
                                            {{ option?.name }}
                                        </voxel-option>
                                    </voxel-autocomplete>
                                </voxel-form-field>
                            </ng-container>

                            <voxel-form-field
                                *ngIf="CONTENT_BOUNDS?.sections?.basic_data?.controls?.address; let control"
                                class="voxel-col-xs-4 voxel-col-sm-4 voxel-col-md-6" [label]="control?.label"
                                [msgErr]="(getMessageError(control, form.get(control?.formControlName)?.errors) | async) || control?.msgErr">
                                <input voxelInput [placeholder]="control?.description"
                                    [formControlName]="control?.formControlName" />
                            </voxel-form-field>

                            <voxel-form-field
                                *ngIf="CONTENT_BOUNDS?.sections?.basic_data?.controls?.economic_activity; let control"
                                class="voxel-col-xs-4 voxel-col-sm-4 voxel-col-md-6 " [label]="control?.label"
                                [msgErr]="(getMessageError(control, form.get(control?.formControlName)?.errors) | async) || control?.msgErr">

                                <input type="text" voxelInput voxelAutocomplete
                                    #includesFilterInputEconomic="voxelAutocomplete"
                                    [formControlName]="(control?.formControlName)" />
                                <app-clean-autocomplete [autocomplete]="economicAutocomplete"></app-clean-autocomplete>
                                <voxel-autocomplete #economicAutocomplete [input]="includesFilterInputEconomic"
                                    filterMode="includes">
                                    <voxel-option value="">{{control?.description}}</voxel-option>
                                    <voxel-option *ngFor="let option of economicActivityList" [value]="option?.id">
                                        {{ option?.name }}
                                    </voxel-option>
                                </voxel-autocomplete>
                            </voxel-form-field>

                            <voxel-form-field
                                *ngIf="isNaturalPerson && CONTENT_BOUNDS?.sections?.basic_data?.controls?.gender; let control"
                                class="voxel-col-xs-4 voxel-col-sm-4 voxel-col-md-6 " [label]="control?.label"
                                [msgErr]="(getMessageError(control, form.get(control?.formControlName)?.errors) | async) || control?.msgErr">                               
                                <voxel-select [formControlName]="control?.formControlName"
                                    [placeholder]="control?.description">
                                    <voxel-option *ngFor="let option of genderList" [value]="option?.id"
                                        [disabled]="false">
                                        {{ option.name }}
                                    </voxel-option>
                                </voxel-select>
                            </voxel-form-field>
                        </div>
                    </form>
                </div>
            </ng-container>

        </voxel-accordion>

    </voxel-accordion-group>


</ng-container>